import "../scss/site.scss"

import React, { useEffect, useState } from "react"

import { useLocation } from "@reach/router"

import { useGSAP } from "@gsap/react"
import gsap from "gsap"
import { Helmet } from "react-helmet"
import FixedHeader from "./fixedHeader"
import Footer, { FooterAlt } from "./footer"
import Header, { HeaderAlt } from "./header"
import PageTransition from "./pageTransition"

const Layout = ({ altFooter, altFixed = false, comingSoon, children, register, isEpisode = false, buttonHide, footer, duration, className = "", fixed, fixedTitle, fixedButton, fixedCaption, fixedLink = "https://bookings12.rmscloud.com/Search/Index/D02A3B0EEE533B81/1/", fixedScroll, altHeader = false }) => {
  const [isHolidaysPage, setIsHolidaysPage] = useState(false)

  const { pathname } = useLocation()

  useEffect(() => {
    const holidaysPage = pathname?.includes("accommodation")
    setIsHolidaysPage(holidaysPage)
  }, [pathname])

  useGSAP(() => {
    const holidaysPage = pathname?.includes("accommodation") || pathname?.includes("journal/")
    if (!holidaysPage) return

    const timeout = setTimeout(() => {
      gsap.set(".masthead:not(.alt):not(.mobile--header)", { opacity: 0, pointerEvents: "none", zIndex: 5 })
    }, 1500)
    if (window?.innerWidth < 768) {
      gsap.set(".mobile--header:not(.holidays)", { opacity: 0, pointerEvents: "none", zIndex: 5 })
    }
    return () => clearTimeout(timeout)
  })

  return (
    <>
      <Helmet>
        <script type='text/javascript' async='' src='https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=UG3EsL'></script>
      </Helmet>
      <PageTransition />
      {fixed === true ? <FixedHeader isAlt={altFixed} comingSoon={comingSoon} isEpisode={isEpisode} duration={duration} title={fixedTitle} caption={fixedCaption} button={fixedButton} link={fixedLink} scroll={fixedScroll} /> : ""}
      <HeaderAlt buttonHide={buttonHide} fixedLink={fixedLink} register={register} isAlt={altHeader} />
      <Header buttonHide={buttonHide} fixedLink={fixedLink} register={register} isAlt={altHeader} />
      <main className={className}>
        <div className='mh-80'>{children}</div>
        {footer !== false && altFooter !== true ? <Footer /> : ""}
        {altFooter ? <FooterAlt /> : ""}
      </main>
      <div id='modal-container' />
    </>
  )
}

export default Layout
